import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';
import './NoFarecards.css';
import image from './NoFarecards.svg';

type NoFarecardsProps = {
  goToAdd: () => void;
};

export default function NoFarecards({ goToAdd }: NoFarecardsProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 pt-2 ion-text-center h1plus">{t('farecards.addcard')}</h1>
      <p className="pt-1 instructions">{t('farecards.addinfo')}</p>

      <div className="pt-3 farcards-nocard" onClick={() => goToAdd()}>
        <img src={image} alt={t('farecards.addcard')!} />
      </div>

      <div className="pt-5 ion-text-center">
        <IonButton
          className="btn-default btn-wide-80"
          onClick={() => goToAdd()}
        >
          {t('farecards.addcard')}
        </IonButton>
      </div>

      <div className="pt-5 ion-text-center">
        <a
          className="farecards-infolink"
          href={t('farecards.infourl')!}
          rel={'noreferrer'}
          target={'_blank'}
        >
          {t('farecards.infohint')}
        </a>
      </div>
    </>
  );
}
